import React from 'react';
import ProductPage from '../components/ProductPage';
import { DALCOMM_INTERCOM_KIT_IMAGES } from '../data/dalcomm';

const DalcommIntercomKitPage = ({ onRequestDemo, onRequestQuote }) => {
  const productData = {
    productName: 'Wireless Intercom Kit — Airline / Airport Use',
    partNumber: 'DALCOMM-WIRELESS-INTERCOM',
    tagline: 'Wireless Pushback Communication for Ground Crews',
    metaDescription: 'Dalcomm wireless intercom kit for pushback and towing: 915 MHz radio headsets that talk directly to each other, with a gateway tying in the flight-deck interphone.',
    description:
      'The Dalcomm Wireless Intercom Kit provides a way for ground crew performing aircraft movements at airports to talk to each other and the flight deck. A set of wireless headsets talk to each other directly on a 915 MHz license-free band, while a gateway connects to the aircraft external intercom jack so the flight-deck interphone is tied into the wireless work group. Because the headsets are built like a radio (not DECT), they talk directly to each other with no gateway required — the gateway only adds the aircraft bridge.',
    image: DALCOMM_INTERCOM_KIT_IMAGES[0],
    images: DALCOMM_INTERCOM_KIT_IMAGES,
    imageContain: true,
    features: [
      {
        title: '550 ft Headset-to-Headset Range',
        description:
          '915 MHz medical/industrial/scientific band — no FCC license needed and 550 ft of clean range from headset to headset and headset to gateway.',
      },
      {
        title: 'Up to 8 Headsets per Work Group',
        description:
          'Configure up to 8 headsets in a single work group. Colored group-ID rings (7 colors, stackable up to 3 per headset) allow 343 possible work groups on the ramp at once.',
      },
      {
        title: 'No Gateway Required for Peer Comms',
        description:
          'Headsets are built like a radio, not DECT — every headset talks to every other headset directly. The gateway only adds the bridge to the aircraft interphone.',
      },
      {
        title: 'Internal Antenna',
        description:
          'Headsets and gateway are upgraded to an internal antenna. Fewer parts to break, fewer FOD sources on the ramp.',
      },
      {
        title: 'One-Knob On / Off / Volume',
        description:
          'Single rotary knob — click to turn on, keep turning to raise volume. No menus, no pairing dance, no setup between shifts.',
      },
      {
        title: 'Real-Time Battery Indicator',
        description:
          'Four-LED battery indicator (green / green / yellow / red) on the side of the headset shows charge state at a glance. No voice prompts, no flash-code counting.',
      },
      {
        title: 'Aircraft-Cable Flexibility',
        description:
          'Ships with the interphone plug your fleet uses: 1/4", twin GA, or U-174/U helicopter plug (civilian or military pinout).',
      },
      {
        title: 'Case with Built-in Charging',
        description:
          'The wheeled kit case has a built-in charging system with a power-supply brick and multi-port USB hidden in the foam. Extension cord included.',
      },
      {
        title: 'Colored Group-ID Rings',
        description:
          '7 rubber ring colors at the headband-to-ear-cup joint let you visually identify work groups instantly. Reassign a group in seconds by swapping rings.',
      },
      {
        title: 'Programming Software',
        description:
          'Dalcomm Wireless software provides drop-down menus for setting work groups. Set once, then swap the colored band on the headset — no downtime.',
      },
    ],
    specifications: [
      { label: 'Frequency Band', value: '915 MHz (MICS / industrial / scientific, license-free)' },
      { label: 'Range', value: '550 ft (headset-to-headset and headset-to-gateway)' },
      { label: 'Max Headsets per Group', value: '8' },
      { label: 'Available Work Groups', value: '343 (7 ring colors × up to 3 rings per headset)' },
      { label: 'Antenna', value: 'Internal (both headsets and gateway)' },
      { label: 'Headset Controls', value: 'Single on/off/volume rotary knob' },
      { label: 'Battery Indicator', value: '4-LED green/green/yellow/red' },
      { label: 'Aircraft Cable Options', value: '1/4" plug · Twin GA plugs · U-174/U helicopter (civilian or military pinout)' },
      { label: 'Kit Sizes', value: 'Deicing (2-user) · 3-Person · 4-Person' },
      { label: 'Battery Backup', value: 'Optional (0 – 4 backups per kit)' },
      { label: 'Case', value: 'Wheeled hard case with built-in charging + extension cord' },
      { label: 'Price Range', value: '$2,430 – $7,070 depending on configuration' },
    ],
    applications: [
      'Pushback and towing at airline gates',
      'Deicing crew comms in bad-weather ops',
      'Ramp and turnaround operations',
      'Wing walker + driver + supervisor coordination',
      'Widebody and narrowbody pushback with flight-deck bridge',
      'Cross-fleet operations where crews use both GA-plug and 1/4"-plug interphones',
      'Line maintenance requiring hands-free comms with the flight deck',
      'Training and check-ride use with a supervisor headset in the work group',
    ],
    heroExtra:
      'Available as a 2-user Deicing Kit, 3-Person Kit, or 4-Person Kit — all with built-in case charging.',
  };

  return <ProductPage {...productData} onRequestDemo={onRequestDemo} onRequestQuote={onRequestQuote} />;
};

export default DalcommIntercomKitPage;
